import { useAtomValue } from "jotai";
import {
  dictionaryReverse,
  dictionaryValueMap,
} from "datasheets/model/utils/dictionaryUtils";
import { DataSet } from "datasheets/model/core/Workbook";
import { datasetsAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";
import { KeyedElementSelection } from "./KeyedElementSelection";

export function DataSetSelector({
  selection,
  onSelect,
  title = "Select Dataset",
}: {
  selection: string | undefined;
  onSelect: (datasetId: string) => void;
  title?: string;
}) {
  const datasets = useAtomValue(datasetsAtom);
  const datasetIdToName = dictionaryValueMap(
    datasets,
    (dataset: DataSet) => dataset.name
  );
  const datasetNames = dictionaryReverse(datasetIdToName);
  return (
    <KeyedElementSelection
      title={title}
      labelToKey={datasetNames}
      keyToLabel={datasetIdToName}
      selection={selection}
      availableKeys={[]}
      onChange={onSelect}
      isSingleSelection={true}
    />
  );
}
